'use strict';

const targetFields = ["street", "city", "postalCode", "houseNumber"];

const SELECTORS = {
    body: document.querySelector('body'),
    addressValidationModal: document.querySelector('#addressValidationModal'),
    addressValidationModalJS: document.querySelector('.js-modal-address-validation'),
    modalTitle : $(document.querySelector('.js-modal-address-validation')).find('#addressValidationModal-title'),
    containerTitle : $(document.querySelector('.js-modal-address-validation')).find('#addressValidationContainer-title'),
    containerInfo : $(document.querySelector('.js-modal-address-validation')).find('#addressValidationContainer-info'),
    buttonWraper: $(document.querySelector('.js-modal-address-validation')).find('#addressValidationContainer-buttonWrapper'),
    buttonRecommended: $(document.querySelector('.js-modal-address-validation')).find('.js-modal-address-validation-button-recommended'),
    buttonFallback: $(document.querySelector('.js-modal-address-validation')).find('.js-modal-address-validation-button-fallback')
};

/**
 * Populate the Billing Address Summary View
 * @param {string} parentSelector - the top level DOM selector for a unique address summary
 * @param {Object} address - the address data
 */
function populateAddressSummary(parentSelector, address) {
    $.each(address, function (attr) {
        var val = address[attr];
        $('.' + attr, parentSelector).text(val || '');
    });
}

/**
 * returns a formed <option /> element
 * @param {Object} shipping - the shipping object (shipment model)
 * @param {boolean} selected - current shipping is selected (for PLI)
 * @param {order} order - the Order model
 * @param {Object} [options] - options
 * @returns {Object} - the jQuery / DOMElement
 */
function optionValueForAddress(shipping, selected, order, options) {
    var safeOptions = options || {};
    var isBilling = safeOptions.type && safeOptions.type === 'billing';
    var className = safeOptions.className || '';
    var isSelected = selected;
    var isNew = !shipping;
    if (typeof shipping === 'string') {
        return $('<option class="' + className + '" disabled>' + shipping + '</option>');
    }
    var safeShipping = shipping || {};
    var shippingAddress = safeShipping.shippingAddress || {};

    if (isBilling && isNew && !order.billing.matchingAddressId) {
        shippingAddress = order.billing.billingAddress.address || {};
        isNew = false;
        isSelected = true;
        safeShipping.UUID = 'manual-entry';
    }

    var uuid = safeShipping.UUID ? safeShipping.UUID : 'new';
    var optionEl = $('<option class="' + className + '" />');
    optionEl.val(uuid);

    var title;

    if (isNew) {
        title = order.resources.addNewAddress;
    } else {
        title = [];
        if (shippingAddress.firstName) {
            title.push(shippingAddress.firstName);
        }
        if (shippingAddress.lastName) {
            title.push(shippingAddress.lastName);
        }
        if (shippingAddress.address1) {
            title.push(shippingAddress.address1);
        }
        if (shippingAddress.address2) {
            title.push(shippingAddress.address2);
        }
        if (shippingAddress.city) {
            title.push(shippingAddress.city);
        }
        if (shippingAddress.postalCode) {
            title.push(shippingAddress.postalCode);
        }
        if (!isBilling && safeShipping.selectedShippingMethod) {
            title.push('-');
            title.push(safeShipping.selectedShippingMethod.displayName);
        }

        if (title.length > 2) {
            title = title.join(' ');
        } else {
            title = order.resources.newAddress;
        }
    }
    optionEl.text(title);

    var keyMap = {
        'data-first-name': 'firstName',
        'data-last-name': 'lastName',
        'data-address1': 'address1',
        'data-address2': 'address2',
        'data-address3': 'address3',
        'data-city': 'city',
        'data-postal-code': 'postalCode',
        'data-country-code': 'countryCode',
        'data-title': 'title',
        'data-street-number' : 'streetNumber',
        'data-api-distributioncodedp' : 'APIDistributionCodeDP',
        'data-name-co': 'nameCo'
    };
    $.each(keyMap, function (key) {
        var mappedKey = keyMap[key];
        var mappedValue = shippingAddress[mappedKey];
        // In case of country code
        if (mappedValue && typeof mappedValue === 'object') {
            mappedValue = mappedValue.value;
        }

        optionEl.attr(key, mappedValue || '');
    });

    var giftObj = {
        'data-is-gift': 'isGift',
        'data-gift-message': 'giftMessage'
    };

    $.each(giftObj, function (key) {
        var mappedKey = giftObj[key];
        var mappedValue = safeShipping[mappedKey];
        optionEl.attr(key, mappedValue || '');
    });

    if (isSelected) {
        optionEl.attr('selected', true);
    }

    return optionEl;
}

/**
 * returns address properties from a UI form
 * @param {Form} form - the Form element
 * @returns {Object} - a JSON object with all values
 */
function getAddressFieldsFromUI(form) {
    var address = {
        firstName: $('input[name$=_firstName]', form).val(),
        lastName: $('input[name$=_lastName]', form).val(),
        address1: $('input[name$=_address1]', form).val(),
        address2: $('input[name$=_address2]', form).val(),
        address3: $('input[name$=_address3]', form).val(),
        city: $('input[name$=_city]', form).val(),
        postalCode: $('input[name$=_postalCode]', form).val(),
        countryCode: $('[name$=_country]', form).val(),
        title: $('select[name$=_title]', form).val(),
        streetNumber: $('input[name$=_streetNumber]', form).val(),
        APIDistributionCodeDP: $('[id$=_APIDistributionCodeDP]', form).val(),
        nameCo: $('input[name$=_nameCo]', form).val(),
    };
    return address;
}

//perform a backend service call to check address validity
function checkAddressValidity($form) {
    let validateCountries = 'data-check-address-validity-in-countries';
    if(!$(`[${validateCountries}]`).attr(validateCountries).includes($('[name$=_country]', $form).val())){
        return false;
    }

    return new Promise((resolve, reject) => {
        var dataToValidate = {
            'address': $('input[name$=_address1]', $form).val(),
            'houseNumber': $('input[name$=_streetNumber]', $form).val(),
            'postalCode': $('input[name$=_postalCode]', $form).val(),
            'city': $('input[name$=_city]', $form).val(),
            'country': $('[name$=_country]', $form).val()
        };

        var newAddressValidityRequest = $.ajax({
            url: $('[data-check-address-validity-url]').data('check-address-validity-url'),
            method: 'POST',
            dataType: 'json',
            data: dataToValidate
        });

        newAddressValidityRequest.done(function (data) {
            const response = data && data.addressValidationResponse;
            if (typeof (data && data.serviceEnabled) == 'boolean' && !data.serviceEnabled) {
                resolve(data.serviceEnabled);
                return;
            }

            if (typeof (response && response.success) !== 'boolean') {
                reject(response);
                return;
            }

            if (response.success === false) {
                resolve({ addressNotFound: 'true' });
                return;
            }

            const hasChanges = hasAddressChanges(response);
            const baseResult = {
                hasAddressChanged: hasChanges ? 'true' : 'false',
                // Preserve previous behavior of stringified nulls
                distributionCodeDP: String(getDistributionCodeDP(response))
            };

            if (hasChanges) {
                
                const changed = extractChangedAddressFields(response) || {};
                if (response.address.similarity < (data.minAutoCorrectScoreThreshold || 1.0)) {
                    resolve(mergeWithChangedAddressFields(changed, baseResult));
                    //console.log('>> OPEN MODAL: address.score < minAutoCorrectScoreThreshold:' + response.address.similarity + ' < ' + (data.minAutoCorrectScoreThreshold || 1.0));
                } else {
                    //console.log('>> PROCEED: address.score >= minAutoCorrectScoreThreshold:' + response.address.similarity + ' >= ' + (data.minAutoCorrectScoreThreshold || 1.0));
                    updateChangedFields(mergeWithChangedAddressFields(changed, baseResult).changedAddressFields, $form);
                    resolve({
                        hasAddressChanged: 'false',
                        distributionCodeDP: String(getDistributionCodeDP(response))
                    });
                }
            } else {
                resolve(baseResult);
            }
        });

        newAddressValidityRequest.fail( function(jqXHR, textStatus) {
            const errorResponse =
              '{"error":"Ajax request failed" , "textStatus":"' +
              textStatus +
              '", "errorText":' +
              jqXHR.responseText +
              "}";
            reject(JSON.parse(errorResponse));
        });
    });
}

// Check if the address has changed
function hasAddressChanges(data) {
    if (!data?.address?.changedFields) return false;

    const changed = data.address.changedFields.map(f => f.toLowerCase());
    const targets = targetFields.map(field => field.toLowerCase());
    const allTargetsChanged = targets.every(target => changed.includes(target));

    // All relevant fields changed AND all fields are empty" (NOA-4374)
    if (allTargetsChanged) {
        // We only check the data.address values if we know they were all changed.
        const allTargetFieldsAreEmpty = targetFields.every(field => {
            const value = data.address[field];
            // Check for null, empty string, or undefined (a safer check)
            return value === null || value === '' || value === undefined;
        });

        // If all fields were changed AND the final state of all those fields is empty/null,
        // treat it as no effective change (return false).
        if (allTargetFieldsAreEmpty) {
            return false;
        }
    }

    return targets.some(field => changed.includes(field));
}

// Extract changed address fields
function extractChangedAddressFields(data) {
    if (!data?.address?.changedFields) return null;

    const changedLower = data.address.changedFields.map(function (f) { return f.toLowerCase(); });

    const changedValues = {};

    targetFields.forEach(function (field) {
        if (changedLower.includes(field.toLowerCase())) {
            var keyInAddress = field;
            if (data.address[keyInAddress] !== undefined) {
                // Map field names to the correct keys
                if (field === 'street') {
                    changedValues['address1'] = data.address[keyInAddress];
                } else if (field === 'houseNumber') {
                    changedValues['streetNumber'] = data.address[keyInAddress];
                } else {
                    changedValues[field] = data.address[keyInAddress];
                }
            }
        }
    });
    return Object.keys(changedValues).length > 0 ? changedValues : null;
}

// Function to get the distribution code DP from the address
function getDistributionCodeDP(data) {
    return data?.address?.distributionCodeDP || null;
}

// Merge changed address fields with the base result
function mergeWithChangedAddressFields(obj1, obj2) {
  return {
    changedAddressFields: obj1,
    ...obj2
  };
}

// Update changed fields in the form
function updateChangedFields(changedFields, form) {
    if (!changedFields || typeof changedFields !== 'object') {
        return [];
    }

    Object.entries(changedFields).forEach(([field, value]) => {
        form.find('input[name$=_' + field + ']').val(value);
    });
    return [{'success': true, 'message': 'Changed fields updated successfully'}];
}

// Helper function to update distribution code
function updateDistributionCode(form, distributionCodeDP) {
    if (distributionCodeDP) {
        form.find('input[name$=_APIDistributionCodeDP]').val(distributionCodeDP);
    }
}

// Helper function to handle address validation modal
function handleAddressValidationModal(resultAddressValidity, form) {
    
    const $modal = $(SELECTORS.addressValidationModalJS);

    if (!$modal || !$modal.length) return;

    // Check if the form has is a billing address form
    if (form.hasClass('js-billing-address-form')) {
        initializeModal($modal, 'billing', form);
        // Build and display address information using original form values
        buildAddressInfo({}, form, $modal);
    } else {
        if (resultAddressValidity?.hasAddressChanged === 'true') {
            initializeModal($modal, 'shippingChanged', resultAddressValidity, form);
            // Build and display address information using resultAddressValidity values
            buildAddressInfo(resultAddressValidity, form, $modal);
        } else if (resultAddressValidity?.addressNotFound === 'true') {
            initializeModal($modal, 'shippingNotFound', form);
            // Build and display address information using original form values
            buildAddressInfo({}, form, $modal);
        }
    }

    $(SELECTORS.addressValidationModal).modal();
}

// Helper to toggle visibility via d-none
function toggleVisible($el, show) {
    if (!$el || !$el.length) return;
    $el.toggleClass('d-none', !show);
}

// Helper to initialize modal based on scenario
function initializeModal($modal, mode, resultAddressValidity, form) {

    const $modalTitle        =  $(SELECTORS.modalTitle);     // e.g. Lieferadresse unbekannt
    const $containerTitle    =  $(SELECTORS.containerTitle); // e.g. Eingegebene Adresse
    const $containerInfo     =  $(SELECTORS.containerInfo);  // e.g. Wenn deine Adresse korrekt ist ...
    const $buttonWraper      = $(SELECTORS.buttonWraper);
    const $buttonRecommended = $(SELECTORS.buttonRecommended);
    const $buttonFallback    = $(SELECTORS.buttonFallback);

    switch (mode) {
        case 'shippingNotFound': {
            $modalTitle.text($modalTitle.data('shipping-address-notfound-title'));
            setAlertState($modal, { notFound: true, changed: false, billing: false });
            $containerTitle.text($containerTitle.data('address-container-not-found-title'));
            $containerInfo.show().html($containerInfo.data('shipping-address-info-not-found'));
            // recommended acction "close modal", user can change address again
            $buttonRecommended.text($buttonWraper.data('button-change-address'));
            $buttonRecommended.off('click.handleAddressFromModal');
            // fallback action "submit not validated customer address"
            $buttonFallback.text($buttonWraper.data('button-useanyway-address'));
            $buttonFallback.off('click.handleAddressFromModal').on('click.handleAddressFromModal', function() {
                updateDistributionCode(form, resultAddressValidity.distributionCodeDP);
                submitShipping($('button.submit-shipping'));
            });
            break;
        }
        case 'shippingChanged': {
            $modalTitle.text($modalTitle.data('shipping-address-changed-title'));
            setAlertState($modal, { notFound: false, changed: true, billing: false });
            $containerTitle.text($containerTitle.data('address-container-changed-title'));
            $containerInfo.hide();
            // recommended action "update suggested address in form and submit"
            $buttonRecommended.text($buttonWraper.data('button-accept-address'));
            $buttonRecommended.off('click.handleAddressFromModal').on('click.handleAddressFromModal', function() {
                updateChangedFields(resultAddressValidity.changedAddressFields, form);
                updateDistributionCode(form, resultAddressValidity.distributionCodeDP);
                submitShipping($('button.submit-shipping'));
            });
            // fallback action "close modal", user can change address again
            $buttonFallback.text($buttonWraper.data('button-change-address')); 
            $buttonFallback.off('click.handleAddressFromModal');
            break;
        }
        case 'billing': {
            $modalTitle.text($modalTitle.data('billing-address-title'));
            setAlertState($modal, { notFound: false, changed: false, billing: true });
            $containerTitle.text($containerTitle.data('address-container-not-found-title'));
            $containerInfo.show().html($containerInfo.data('billing-address-info-not-found'));
            // recommended action "close modal", user can change address again
            $buttonRecommended.text($buttonWraper.data('button-change-address'));
            $buttonRecommended.off('click.handleAddressFromModal');
            // fallback action  "submit not validated customer address"
            $buttonFallback.text($buttonWraper.data('button-useanyway-address'));
            $buttonFallback.off('click.handleAddressFromModal').on('click.handleAddressFromModal', function() {
                submitBilling($('button.submit-billing'));
            });
            break;
        }
        default:
            break;
    }
}

// Helper to toggle alert areas
function setAlertState($modal, { notFound = false, changed = false, billing = false }) {
    const $alertNotFound = $modal.find('.js-modal-address-validation-alert-not-found');
    const $alertChanged = $modal.find('.js-modal-address-validation-alert-changed');
    const $alertBilling = $modal.find('.js-modal-address-validation-alert-billing');
    const $subtitleInfo = $modal.find('.js-modal-address-validation-subtitle-info-not-found');

    toggleVisible($subtitleInfo, true);
    toggleVisible($alertNotFound, notFound);
    toggleVisible($alertChanged, changed);
    toggleVisible($alertBilling, billing);
}

// Helper to submit billing
function submitBilling($submitBilling) {
    if (!$submitBilling || !$submitBilling.length) return;
    $submitBilling.prop('disabled', false);
    $submitBilling.data('address-validation', 'true');
    $submitBilling.trigger('click');
}

// Helper to submit shipping
function submitShipping($submitShipping) {
    if (!$submitShipping || !$submitShipping.length) return;
    $submitShipping.prop('disabled', false);
    $submitShipping.data('address-validation', 'true');
    $submitShipping.trigger('click');
}

// Returns true if the country in the given form should trigger validation (DE/AT/CH)
function shouldValidateAddressForCountry(form) {
            const country = $('[name$=_country]', form).val();
            return ['DE', 'AT', 'CH'].includes(country);
};

function shouldValidateAddressType(form) {
            const storeName = $('[name$=_storeName]', form).val();
            return storeName?false:true;
};

// Helper function to build address information HTML
function buildAddressInfo(resultAddressValidity, form, $modal) {
    
    let changedFields;
    if (Object.keys(resultAddressValidity).length === 0) {
       changedFields = {}; 
    } else {
       changedFields  = resultAddressValidity.changedAddressFields;
    }

    const addressFields = [
        { key: 'firstName', formField: '_firstName' },
        { key: 'lastName', formField: '_lastName' },
        { key: 'address1', formField: '_address1' },
        { key: 'streetNumber', formField: '_streetNumber' },
        { key: 'postalCode', formField: '_postalCode' },
        { key: 'city', formField: '_city' }
    ];

    const $addressInfoName = $modal.find('.js-modal-address-validation-container-name');
    const $addressInfoStreet = $modal.find('.js-modal-address-validation-container-street');
    const $addressInfoCity = $modal.find('.js-modal-address-validation-container-city');

    // Batch form value retrieval
    const currentAddress = {};
    const formInputs = {};

    // Single jQuery query for all form inputs
    addressFields.forEach(field => {
        var addressElementValue;
        if (resultAddressValidity && resultAddressValidity.changedAddressFields && resultAddressValidity.changedAddressFields.hasOwnProperty(field.key)) {
            addressElementValue = resultAddressValidity.changedAddressFields[field.key];
        } else {
            const $input = form.find(`input[name$=${field.formField}]`);
            addressElementValue = $input.val();
        }
        currentAddress[field.key] = addressElementValue;
    });

    // Update the name element with first and last name
    const firstName = currentAddress.firstName || '';
    const lastName = currentAddress.lastName || '';
    const fullName = `${firstName} ${lastName}`.trim();
    $addressInfoName.text(fullName);

    // Update the street element with street and house number
    const street = currentAddress.address1 || '';
    const houseNumber = currentAddress.streetNumber || '';
    $addressInfoStreet.html(`
        <span class="js-modal-address-validation-container-address1">${street}</span>
        <span class="js-modal-address-validation-container-streetNumber">${houseNumber}</span>
    `);

    // Update the city element with postcode and city
    const postcode = currentAddress.postalCode || '';
    const city = currentAddress.city || '';
    $addressInfoCity.html(`
        <span class="js-modal-address-validation-container-postalCode">${postcode}</span>
        <span class="js-modal-address-validation-container-city">${city}</span>
    `);

    // Mark changed fields
    if (changedFields) {
        // Apply changed-field class to changed elements
        Object.keys(changedFields).forEach(fieldKey => {
            if (changedFields[fieldKey]) {
                switch (fieldKey) {
                    case 'address1':
                        $addressInfoStreet.find('.js-modal-address-validation-container-address1').addClass('cc-modal__address-container__address-value-changed');
                        break;
                    case 'streetNumber':
                        $addressInfoStreet.find('.js-modal-address-validation-container-streetNumber').addClass('cc-modal__address-container__address-value-changed');
                        break;
                    case 'postalCode':
                        $addressInfoCity.find('.js-modal-address-validation-container-postalCode').addClass('cc-modal__address-container__address-value-changed');
                        break;
                    case 'city':
                        $addressInfoCity.find('.js-modal-address-validation-container-city').addClass('cc-modal__address-container__address-value-changed');
                        break;
                }
            }
        });
    }
}

module.exports = {
    methods: {
        populateAddressSummary: populateAddressSummary,
        optionValueForAddress: optionValueForAddress,
        getAddressFieldsFromUI: getAddressFieldsFromUI,
        checkAddressValidity: checkAddressValidity,
        updateDistributionCode: updateDistributionCode,
        shouldValidateAddressForCountry: shouldValidateAddressForCountry,
        shouldValidateAddressType: shouldValidateAddressType,
        handleAddressValidationModal: handleAddressValidationModal
    },

    showDetails: function () {
        $('.btn-show-details').on('click', function () {
            var form = $(this).closest('form');

            form.attr('data-address-mode', 'details');
            form.find('.multi-ship-address-actions').removeClass('d-none');
            form.find('.multi-ship-action-buttons .col-12.btn-save-multi-ship').addClass('d-none');
        });
    },

    addNewAddress: function () {
        $('.btn-add-new').on('click', function () {
            const $el = $(this);
            if ($el.parents('#dwfrm_billing').length > 0) {
                // Handle billing address case
                $('body').trigger('checkout:clearBillingForm');
                var $option = $($el.parents('form').find('.addressSelector option')[0]);
                $option.attr('value', 'new');
                var $newTitle = $('#dwfrm_billing input[name=localizedNewAddressTitle]').val();
                $option.text($newTitle);
                $option.prop('selected', 'selected');
            } else {
                const $form = $('.js-shipping-form');
                $el.addClass('d-none');
                $form.find('.shipping-address-block input:not([type="checkbox"])').val('');
                $form.find('select[name$=_title]').val('')
                $form.find('select[name$=_title]').selectpicker('refresh');
                $('body').trigger('formValidation:reset', $form.attr('name'));
                $form.attr('data-address-mode', 'new');
                $form.find('.shipping-address-block').removeClass('d-none');
                var $countryInput = $form.find('input[name="dwfrm_shipping_shippingAddress_addressFields_country"]');
                $countryInput.val($countryInput.attr('id'));

                const checkedShippingOption = $('.js-shipping-option[name="shippingAddress"]:checked');
                if (checkedShippingOption.length > 0) {
                    checkedShippingOption.prop('checked', false);
                }
            }
        });
    },

    /**
     * In the checkout under delivery address, switches the view to sameAddress if initial data-address-mode='sameAddress' is given.
     * TODO: Temporary solution until the storage of addresses has been changed (save billing address before shipping address). 
     */
    preparInitViewIfDuplicateAddressExists: function () {
        const $form = $('.js-shipping-form');
        if ($form.length > 0 && $form.is("[data-address-mode='sameAddress']")) {
            $('button.submit-shipping').prop('disabled', true);
            const checkedShippingOption = $('.js-shipping-option[name="shippingAddress"]:checked');
            if (checkedShippingOption.length > 0) {
                checkedShippingOption.prop('checked', false);
            }
        }
    }
};